var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background",on:{"click":_vm.onClose}},[_c('div',{staticClass:"pop-up"},[_c('div',{staticClass:"qrcode-wrap"},[_c('VueQRCodeComponent',{staticClass:"qr",attrs:{"text":_vm.inputText,"size":170}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }